import PageContainer from '../page-container/page-container';
import AfterPurchaseModal from './after-purchase-modal';
import { BgSkeleton } from './bg-sekelton';

const AfterPurchase = () => {
  return (
    <PageContainer helmet="Thank You">
      <AfterPurchaseModal />
      <BgSkeleton />
    </PageContainer>
  );
};

export default AfterPurchase;
